export const Position = [
  'CEO',
  'CFO',
  'COO',
  'Other_officer_or_director',
  '10_Shareholder'
];
